import React from "react";
import { StyledFormElementsWrapper, FormLabel } from "../styles";
import { CustomFileUpload } from "../../../common/FormInputs";
import styled from "styled-components";
import theme from "../../../../assets/theme";
import COLORS from "../../../../assets/Colors";

const AddSignature = ({ values, errors, touched, setFieldValue }) => {
  return (
    <StyledFormElementsWrapper
      style={{ marginBottom: 8, marginTop: 15 }}
      width="100%"
    >
      <SectionTitle>
        <SectionIcon>{"✍️"}</SectionIcon>
        Add Signature
      </SectionTitle>

      <InfoBanner>
        <span>{"ℹ️"}</span>
        <span>
          Upload a clear image of the signature (PNG, JPG recommended). Max
          size: 3MB.
        </span>
      </InfoBanner>

      <UploadBlock>
        <FormLabel>
          Add Signature <span className="required-star"> *</span>
        </FormLabel>
        <CustomFileUpload
          error={touched["addSignature"] && errors["addSignature"]}
          setFile={(file) => setFieldValue("addSignature", file)}
          style={{ width: "60%" }}
          accept="image/*"
          file={{ name: values["addSignature"]?.name || "" }}
        />
      </UploadBlock>
    </StyledFormElementsWrapper>
  );
};

export default AddSignature;

const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 16px;
  font-weight: 700;
  color: ${COLORS.COLOR_DARK};
  margin-bottom: 20px;
  padding-bottom: 14px;
  border-bottom: 1.5px solid rgba(0, 131, 140, 0.1);
`;

const SectionIcon = styled.span`
  width: 32px;
  height: 32px;
  background: linear-gradient(
    135deg,
    rgba(0, 131, 140, 0.12),
    rgba(105, 227, 194, 0.15)
  );
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
`;

const InfoBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(
    135deg,
    rgba(0, 131, 140, 0.05),
    rgba(105, 227, 194, 0.08)
  );
  border: 1.5px solid rgba(0, 131, 140, 0.15);
  border-radius: 12px;
  padding: 12px 16px;
  margin-bottom: 24px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 13px;
  color: ${COLORS.COLOR_DARK};
  line-height: 1.5;
`;

const UploadBlock = styled.div`
  margin-top: 10px;
`;
